import axios from "axios";

const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_BASE_URL ||
    "https://www.dancap-group.co.uk/strapi/api/",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = process.env.REACT_APP_STRAPI_TOKEN;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
